import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { SquaresFour, Package, Certificate, ArrowsLeftRight, ChartLineUp, GearSix, SignOut } from "@phosphor-icons/react";
import { Wordmark } from "./Logo";
import { api, getMerchantId, getMerchantName, setMerchantName, clearMerchant } from "../lib/api";

const links = [
  { to: "/dashboard", label: "Dashboard", icon: SquaresFour, id: "nav-dashboard" },
  { to: "/products", label: "Products", icon: Package, id: "nav-products" },
  { to: "/passports", label: "Passports", icon: Certificate, id: "nav-passports" },
  { to: "/transfers", label: "Transfers", icon: ArrowsLeftRight, id: "nav-transfers" },
  { to: "/analytics", label: "Analytics", icon: ChartLineUp, id: "nav-analytics" },
  { to: "/settings", label: "Settings", icon: GearSix, id: "nav-settings" },
];

export const Sidebar = () => {
  const navigate = useNavigate();
  const [name, setName] = useState(getMerchantName());
  useEffect(() => {
    const id = getMerchantId();
    if (id && getMerchantName() === "Merchant") {
      api.get(`/merchants/${id}`).then(({ data }) => {
        if (data?.merchant_name) { setMerchantName(data.merchant_name); setName(data.merchant_name); }
      }).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const logout = () => {
    clearMerchant();
    navigate("/install");
  };
  return (
    <aside className="hidden lg:flex flex-col w-64 shrink-0 bg-navy text-cream min-h-screen sticky top-0 px-5 py-8">
      <div className="px-2">
        <Wordmark light />
      </div>
      <nav className="mt-12 flex flex-col gap-1">
        {links.map((l) => {
          const Icon = l.icon;
          return (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-colors duration-200 ${
                  isActive ? "bg-gold/15 text-gold" : "text-cream/70 hover:text-cream hover:bg-white/5"
                }`
              }
            >
              <Icon size={20} weight="light" />
              {l.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="mt-auto pt-6 border-t border-white/10">
        <div className="px-4 mb-3">
          <p className="text-[0.6rem] uppercase tracking-[0.2em] text-cream/40">Signed in as</p>
          <p className="text-sm text-cream/90 mt-1 truncate">{name}</p>
        </div>
        <button
          onClick={logout}
          data-testid="logout-button"
          className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-cream/60 hover:text-cream hover:bg-white/5 w-full transition-colors"
        >
          <SignOut size={20} weight="light" />
          Disconnect
        </button>
      </div>
    </aside>
  );
};

export const MobileBar = () => (
  <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-navy text-cream flex justify-around py-2 border-t border-white/10">
    {links.map((l) => {
      const Icon = l.icon;
      return (
        <NavLink key={l.to} to={l.to} className={({ isActive }) => `flex flex-col items-center gap-0.5 px-3 py-1 text-[0.65rem] ${isActive ? "text-gold" : "text-cream/60"}`}>
          <Icon size={22} weight="light" />
          {l.label}
        </NavLink>
      );
    })}
  </div>
);
